import { render, staticRenderFns } from "./AccidentIntakeTreatmentReceivedForm.vue?vue&type=template&id=60de43ac&scoped=true"
import script from "./AccidentIntakeTreatmentReceivedForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeTreatmentReceivedForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeTreatmentReceivedForm.vue?vue&type=style&index=0&id=60de43ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60de43ac",
  null
  
)

export default component.exports